import React, { useState, useEffect, useRef, SyntheticEvent } from "react";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { BASE_URL } from "../services/client/rest";
import Skeleton from "@mui/material/Skeleton";
import Link from "@mui/material/Link";
import { makeStyles } from "@mui/styles";
import Paper from "@mui/material/Paper";
import TableContainer from "@mui/material/TableContainer";
import TablePagination from "@mui/material/TablePagination";
import TableSortLabel from "@mui/material/TableSortLabel";
import TableBody from "@mui/material/TableBody";
import RefreshIcon from "@mui/icons-material/Refresh";
import { visuallyHidden } from "@mui/utils";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import LastPageIcon from "@mui/icons-material/LastPage";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

function descendingComparator(a: any, b: any, orderBy: any) {
  var x = a[orderBy];
  var y = b[orderBy];
  if (orderBy == "cpu") {
    let _x = parseInt(x.replace("%", ""));
    if (isNaN(_x)) {
      _x = 0;
    }
    let _y = parseInt(y.replace("%", ""));
    if (isNaN(_y)) {
      _y = 0;
    }
    if (_y < _x) {
      return -1;
    }
    if (_y > _x) {
      return 1;
    }
    return 0;
  }
  if (y < x) {
    return -1;
  }
  if (y > x) {
    return 1;
  }
  return 0;
}

function getComparator(order: any, orderBy: any) {
  return order === "desc"
    ? (a: any, b: any) => descendingComparator(a, b, orderBy)
    : (a: any, b: any) => -descendingComparator(a, b, orderBy);
}

function stableSort(array: any, comparator: any) {
  const stabilizedThis = array.map((el: any, index: any) => [el, index]);
  stabilizedThis.sort((a: any, b: any) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el: any) => el[0]);
}

const useStyles = makeStyles((theme) => ({
  success: { backgroundColor: "green", color: "white !important" },
  failure: { backgroundColor: "red", color: "white !important" },
  alertHigh: { backgroundColor: "#E74C3C", color: "white !important" },
  alertMedium: { backgroundColor: "orange", color: "white !important" },
  myLink: {
    color: "gray",
    cursor: "pointer",
    marginLeft: "10px",
    "&:hover": { color: "green !important" },
  },
}));
let myRefreshTimer: any;

export default function Aspen({ search }: { search: string }) {
  const classes = useStyles();
  const [data, SetData] = React.useState([] as any);
  const [healthCheckData, SetHealthCheckData] = React.useState([] as any);

  const [showSpinner, SetSpinner] = React.useState(false);
  const [page, setPage] = React.useState(0);
  const [dense, setDense] = React.useState(true);
  const [selected, setSelected] = React.useState([] as any);
  const [order, setOrder] = React.useState<string>("desc");
  const [orderBy, setOrderBy] = React.useState("cpu");
  const [rowsPerPage, setRowsPerPage] = React.useState(20);

  var bearer = "Bearer " + localStorage.getItem("token");

  const useStyles1 = makeStyles((theme: any) => ({
    root: {
      flexShrink: 0,
    },
  }));

  const headCells = [
    { id: "server", numeric: false, disablePadding: false, label: "Server" },
    { id: "cpu", numeric: true, disablePadding: false, label: "CPU(%)" },
    {
      id: "memory",
      numeric: false,
      disablePadding: false,
      label: "Memoroy Usage(%)",
    },
    {
      id: "availableDiskSpace",
      numeric: false,
      disablePadding: false,
      label: "AvailableDiskSpace",
    },
    {
      id: "lastUpdate",
      numeric: false,
      disablePadding: false,
      label: "LastUpdate",
    },
    {
      id: "currentConnections",
      numeric: true,
      disablePadding: false,
      label: "Current Connections",
    },
    {
      id: "Anonymous Users",
      numeric: true,
      disablePadding: false,
      label: "Anonymous Users",
    },
  ];
  const handleChangePage = (event: any, newPage: any) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: any) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleSelectAllClick = (event: any) => {};

  const handleRequestSort = (event: any, property: any) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };
  const isSelected = (name: any) => selected.indexOf(name) !== -1;

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - GetData().length) : 0;

  function GetData() {
    return data.filter(filterRow);
  }
  function filterRow(element: any, index: any, array: any) {
    if (data.length > 0) {
      var obj1 = data[0];
      var keys = Object.keys(obj1);
      let i = 0;
      for (i = 0; i < keys.length; i++) {
        let cellValue = String(element[keys[i]]);
        if (cellValue.toLowerCase().includes(search.toLowerCase())) {
          return true;
        }
      }
    }
    return false;
  }

  function CurrentDateTime() {
    return new Date().toLocaleString();
  }
  function EnhancedTableHead(props: any) {
    const {
      onSelectAllClick,
      order,
      orderBy,
      numSelected,
      rowCount,
      onRequestSort,
    } = props;
    const createSortHandler = (property: any) => (event: any) => {
      onRequestSort(event, property);
    };

    return (
      <TableHead>
        <TableRow>
          {headCells.map((headCell) => (
            <TableCell
              style={{ backgroundColor: "#F2F3F4" }}
              key={headCell.id}
              align={headCell.numeric ? "right" : "left"}
              padding={headCell.disablePadding ? "none" : "normal"}
              sortDirection={orderBy === headCell.id ? order : false}
            >
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : "asc"}
                onClick={createSortHandler(headCell.id)}
              >
                {headCell.label}
                {orderBy === headCell.id ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === "desc"
                      ? "sorted descending"
                      : "sorted ascending"}
                  </Box>
                ) : null}
              </TableSortLabel>
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    );
  }

  EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(["asc", "desc"]).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
  };
  function TablePaginationActions(props: any) {
    const classes = useStyles1();
    const theme: any = useTheme();
    const { count, page, rowsPerPage, onChangePage } = props;

    const handleFirstPageButtonClick = (event: any) => {
      setPage(0);
    };

    const handleBackButtonClick = (event: any) => {
      setPage(page - 1);
    };

    const handleNextButtonClick = (event: any) => {
      setPage(page + 1);
    };

    const handleLastPageButtonClick = (event: any) => {
      setPage(Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
      <div className={classes.root}>
        <IconButton
          onClick={handleFirstPageButtonClick}
          disabled={page === 0}
          aria-label="first page"
        >
          {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
        </IconButton>
        <IconButton
          onClick={handleBackButtonClick}
          disabled={page === 0}
          aria-label="previous page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowRightIcon />
          ) : (
            <KeyboardArrowLeftIcon />
          )}
        </IconButton>
        <IconButton
          onClick={handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="next page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowLeftIcon />
          ) : (
            <KeyboardArrowRightIcon />
          )}
        </IconButton>
        <IconButton
          onClick={handleLastPageButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="last page"
        >
          {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
        </IconButton>
      </div>
    );
  }

  TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onChangePage: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
  };
  useEffect(() => {
    GetEndpointHealth();
    GetAspenServersData();
  }, []);

  function GetEndpointHealth() {
    clearTimeout(myRefreshTimer);

    SetSpinner(true);

    let url = BASE_URL + "Customer/AspenEndpointHealth";

    fetch(url, {
      method: "get",
      headers: new Headers({
        Authorization: bearer,
      }),
    })
      .then((response) => response.json())
      .then((data) => (SetHealthCheckData(data.data), SetSpinner(false)))
      .catch
      //error => alert('Error: ' + error)
      ();
    myRefreshTimer = setTimeout(GetEndpointHealth, 1000 * 60 * 5); //5 min
  }
  function GetAspenServersData() {
    clearTimeout(myRefreshTimer);
    let url = BASE_URL + "ServerInfo/AspenServers";

    fetch(url, {
      method: "get",
      headers: new Headers({
        Authorization: bearer,
      }),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => SetData(data.data))
      .catch((error) => {});

    myRefreshTimer = setTimeout(GetAspenServersData, 1000 * 60 * 1); //1 min
  }
  return (
    <Box display="flex" justifyContent="center" alignItems="center">
      <Box sx={{ width: "auto", display: "table" }}>
        <Paper
          sx={{
            width: "auto",
            mb: 2,
            margin: "10px 10px",
            border: "1px solid #E5E7E9",
          }}
        >
          <TableContainer>
            <Table
              sx={{ minWidth: 750 }}
              aria-labelledby="tableTitle"
              size={dense ? "small" : "medium"}
            >
              <EnhancedTableHead
                numSelected={selected.length}
                order={order}
                orderBy={orderBy}
                onSelectAllClick={handleSelectAllClick}
                onRequestSort={handleRequestSort}
                rowCount={GetData().length}
              />
              <TableBody>
                {stableSort(GetData(), getComparator(order, orderBy))
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row: any, index: any) => {
                    let classAlert = "";
                    if (parseInt(row.cpu.replace("%", "")) >= 50)
                      classAlert = classes.alertMedium;
                    if (parseInt(row.cpu.replace("%", "")) >= 75)
                      classAlert = classes.alertHigh;
                    // const isItemSelected =
                    //   row.id == currentRow.id ? true : false;
                    let lastUpdate = row.lastUpdate.toString();
                    lastUpdate = new Date(
                      row.lastUpdate.toString().replace("T", " ") + " UTC"
                    )
                      .toLocaleString()
                      .replace(",", "");
                    let diskAlert = "";
                    if (row.alertCause === "Low Disk Space.")
                      diskAlert = classes.alertHigh;
                    let memoryAlert = "";
                    if (row.alertCause === "Low RAM Space")
                      memoryAlert = classes.alertHigh;
                    return (
                      <TableRow
                        hover
                        role="checkbox"
                        key={row.id}
                        //onClick={(event) => handleRowClick(row)}
                        //selected={isItemSelected}
                      >
                        <TableCell>{row.server}</TableCell>
                        <TableCell align="right" className={classAlert}>
                          {row.cpu}
                        </TableCell>
                        <TableCell className={memoryAlert}>
                          {row.memory}
                        </TableCell>
                        <TableCell className={diskAlert}>
                          {row.availableDiskSpace}
                        </TableCell>
                        <TableCell>{lastUpdate}</TableCell>
                        <TableCell align="center">
                          {row.currentConnections}
                        </TableCell>
                        <TableCell align="center">
                          {row.anonymousUsers}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                {emptyRows > 0 && (
                  <TableRow
                    style={{
                      height: (dense ? 33 : 53) * emptyRows,
                    }}
                  >
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <table cellPadding={0} cellSpacing={0} style={{ width: "100%" }}>
            <tr>
              <td>
                <div
                  style={{
                    marginLeft: "15px",
                    font: "inherit",
                    fontFamily: "inherit",
                    fontSize: "small",
                    whiteSpace: "nowrap",
                  }}
                >
                  As of {CurrentDateTime()}
                </div>
              </td>
              <td>
                <RefreshIcon
                  className={classes.myLink}
                  onClick={GetAspenServersData}
                ></RefreshIcon>
              </td>
              <td style={{ width: "100%" }}>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 20, 25, 50, 100]}
                  component="div"
                  count={GetData().length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  ActionsComponent={TablePaginationActions}
                />
              </td>
            </tr>
          </table>
        </Paper>

        {showSpinner ? (
          <Box sx={{ width: 750, marginTop: "12px" }}>
            <Skeleton animation="wave" height={40} />
            <Skeleton animation="wave" height={40} />
            <Skeleton animation="wave" height={40} />
            <Skeleton animation="wave" height={40} />
            <Skeleton animation="wave" height={40} />
            <Skeleton animation="wave" height={40} />
            <Skeleton animation="wave" height={40} />
          </Box>
        ) : (
          <Box sx={{ width: "auto", display: "table" }}>
            <Box style={{ display: "table" }}>
              <fieldset
                style={{
                  fontSize: "18pt",
                  fontWeight: "bold",
                  border: "1px solid silver",
                }}
              >
                <legend>&nbsp;Aspen Statistics&nbsp;</legend>
                <Table
                  sx={{ minWidth: 650 }}
                  aria-label="simple table"
                  className={"myTable"}
                >
                  <TableHead>
                    <TableRow>
                      <TableCell style={{ fontSize: "15pt" }}>Url</TableCell>
                      <TableCell style={{ fontSize: "15pt" }}>Status</TableCell>
                      <TableCell style={{ fontSize: "15pt" }}>
                        ResponseTime
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  {healthCheckData.map((row: any, index: any) => {
                    let colorClass = "";
                    if (row.status === "Success") colorClass = classes.success;

                    if (row.status === "Failure") colorClass = classes.failure;
                    return (
                      <TableRow
                        hover
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                        role="checkbox"
                      >
                        <TableCell>
                          <Link
                            href={row.url}
                            target="_blank"
                            underline="hover"
                          >
                            {row.url}
                          </Link>
                        </TableCell>

                        <TableCell
                          className={colorClass}
                          style={{ fontSize: "15pt" }}
                        >
                          {row.status}
                        </TableCell>
                        <TableCell style={{ fontSize: "15pt" }}>
                          {row.responseTime}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </Table>
              </fieldset>
            </Box>
          </Box>
        )}
      </Box>
    </Box>
  );
}
